import { render, staticRenderFns } from "./the-groups.vue?vue&type=template&id=7853ad4b"
import script from "./the-groups.vue?vue&type=script&lang=js"
export * from "./the-groups.vue?vue&type=script&lang=js"
import style0 from "./the-groups.vue?vue&type=style&index=0&id=7853ad4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports